const products = [
  {
    id: 'A',
    title: "スプリングリフト",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST1/ST1_SPRING_LIFT_550_A.b6494669.png",
    category: "st1",
    url: "https://flowdia.jp/new-products.html?#springLift",
  },
  {
    id: "B",
    title: "スリークライト",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST1/ST1_SLEEK_LIGHT_550_B.20c7f94a.png",
    category: "st1",
    url: "https://flowdia.jp/new-products.html?#sleekLight",
  },
  {
    id: "C",
    title: "スリークモイスト",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST1/ST1_SLEEK_MOIST_550_C.17548c05.png",
    category: "st1",
    url: "https://flowdia.jp/new-products.html?#sleekMoist",
  },
  {
    id: "D",
    title: "ディープモイスト",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST1/ST1_DEEP_MOIST_550_D.fc3c7e36.png",
    category: "st1",
    url: "https://flowdia.jp/new-products.html?#deepMoist",
  },
  {
    id: "E",
    title: "ST2-V",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST2/ST2-V_150_E.png",
    category: "st2",
    url: "#/home-care#ST2V",
  },
  {
    id: "F",
    title: "ST2-C",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST2/ST2-C_150_F.png",
    category: "st2",
    url: "#/home-care#ST2C",
  },
  {
    id: "G",
    title: "ST2-M   ",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST2/ST2-M_150_G.png",
    category: "st2",
    url: "#/home-care#ST2M",
  },
  {
    id: "H",
    title: "ST3",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST3/ST3_H.png",
    category: "st3",
    url: "#/home-care#ST3",
  },
  {
    id: "I",
    title: "ST3-F",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST3/ST3-F_450_I.png",
    category: "st3",
    url: "#/home-care#ST3F",
  },
  {
    id: "J",
    title: "スプリングリフト",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST4/ST4_SPRING_LIFT_550_J.png",
    category: "st4",
    url: "https://flowdia.jp/new-products.html?#springLift",
  },
  
  {
    id: "K",
    title: "スリークライト",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST4/ST4_SLEEK_LIGHT_550_K.png",
    category: "st4",
    url: "https://flowdia.jp/new-products.html?#sleekLight",
  },
  
  {
    id: "L",
    title: "スリークモイスト",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST4/ST4_SLEEK_MOIST_550_L.png",
    category: "st4",
    url: "https://flowdia.jp/new-products.html?#sleekMoist",
  },
  {
    id: "M",
    title: "ディープモイスト",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST4/ST4_DEEP_MOIST_550_M.png",
    category: "st4",
    url: "https://flowdia.jp/new-products.html?#deepMoist",
  },
  {
    id: "N",
    title: "グランストレッチ",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST1/ST1_Grand_stretch.png",
    category: "st1",
    url: "https://flowdia.jp/agingcare_products.html?#grandStretch",
    imageHomecare: "HomeCare/Shampoo/Shampoo_Grand_stretch.png",
  },
  {
    id: "O",
    title: "グランメロウ",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST1/ST1_Grand_mellow.png",
    category: "st1",
    url: "https://flowdia.jp/agingcare_products.html?#grandMellow",
    imageHomecare: "HomeCare/Shampoo/Shampoo_Grand_mellow.png",
  },
  {
    id: "P",
    title: "グランストレッチ",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST4/ST4_Grand_stretch.png",
    category: "st4",
    url: "https://flowdia.jp/agingcare_products.html?#grandStretch",
    imageHomecare: "HomeCare/Treatment/Treatment_Grand_stretch.png",
  },
  {
    id: "Q",
    title: "グランメロウ",
    body: "lorem ipsuim",
    price: 111.0,
    image: "ST4/ST4_Grand_mellow.png",
    category: "st4",
    url: "https://flowdia.jp/agingcare_products.html?#grandMellow",
    imageHomecare: "HomeCare/Treatment/Treatment_Grand_mellow.png",
  },
];

export default products